import React from 'react'
import ReactDOM from 'react-dom/client'
import 'lenis/dist/lenis.css'
import App from './App'
import './index.css'

// Verify the root element exists before rendering
const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Root element not found. Check your index.html file.')
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)